import { BoxDetailAuditProps } from '@/box/interface'
import { getOptions } from '@/shared/SelectData'
import { SelectItem } from '@/shared/SelectItem'
import { getFormatMessage } from '@/utils/utils'
import { SearchOutlined } from '@ant-design/icons'
import { Button, Select, Space, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import moment from 'moment'

export const BoxDetailAudit: React.FC<BoxDetailAuditProps> = (
  props: BoxDetailAuditProps
) => {
  const [type, setType] = useState<number>(0)
  const formatMessage = getFormatMessage()
  const columns = [
    {
      title: formatMessage({ id: 'app.box.detail.audit.index' }),
      key: 'app.box.detail.audit.index',
      render: (text: any, record: any, index: any) => index + 1
    },
    {
      title: formatMessage({ id: 'app.box.detail.audit.creationTime' }),
      key: 'app.box.detail.audit.creationTime',
      render: (text: any, record: any, index: any) => {
        return moment(record.creationTime).local().format('YYYY-MM-DD HH:mm:ss')
      }
    },
    {
      title: formatMessage({ id: 'app.box.detail.audit.type' }),
      key: 'app.box.detail.audit.type',
      render: (text: any, record: any, index: any) => {
        return formatMessage({ id: `app.box.detail.audit.type.${record.type}` })
      }
    },
    {
      title: formatMessage({ id: 'app.box.detail.audit.content' }),
      key: 'app.box.detail.audit.content',
      render: (text: any, record: any, index: any) => {
        return formatMessage({
          id: `app.box.detail.audit.template.${record.type}`,
          parameters: record.args
        })
      }
    },
    {
      title: formatMessage({ id: 'app.box.detail.audit.creator' }),
      key: 'app.box.detail.audit.creator',
      dataIndex: 'creator'
    }
  ]
  const logTypes: SelectItem[] = [
    { text: formatMessage({ id: 'app.box.detail.audit.type.0' }), value: 0 },
    { text: formatMessage({ id: 'app.box.detail.audit.type.1' }), value: 1 },
    { text: formatMessage({ id: 'app.box.detail.audit.type.2' }), value: 2 },
    { text: formatMessage({ id: 'app.box.detail.audit.type.3' }), value: 3 },
    { text: formatMessage({ id: 'app.box.detail.audit.type.4' }), value: 4 },
    { text: formatMessage({ id: 'app.box.detail.audit.type.5' }), value: 5 },
    { text: formatMessage({ id: 'app.box.detail.audit.type.6' }), value: 6 },
    { text: formatMessage({ id: 'app.box.detail.audit.type.7' }), value: 7 },
    { text: formatMessage({ id: 'app.box.detail.audit.type.8' }), value: 8 },
    { text: formatMessage({ id: 'app.box.detail.audit.type.9' }), value: 9 },
    { text: formatMessage({ id: 'app.box.detail.audit.type.10' }), value: 10 },
    { text: formatMessage({ id: 'app.box.detail.audit.type.11' }), value: 11 },
    { text: formatMessage({ id: 'app.box.detail.audit.type.12' }), value: 12 },
    { text: formatMessage({ id: 'app.box.detail.audit.type.13' }), value: 13 },
    // { text: formatMessage({ id: 'app.box.detail.audit.type.14' }), value: 14 },
    // { text: formatMessage({ id: 'app.box.detail.audit.type.15' }), value: 15 },
    { text: formatMessage({ id: 'app.box.detail.audit.type.16' }), value: 16 }
  ]

  const handleClearClick = () => {
    setType(0)
    if (props.onSearch) {
      props.onSearch({ type: 0 })
    }
  }

  const handleSearchClick = () => {
    if (props.onSearch) {
      props.onSearch({ type })
    }
  }

  useEffect(() => {
    setType(0)
  }, [props.boxNo])

  return (
    <div>
      {props.toolbar !== false && (
        <Space style={{ marginBottom: 16 }}>
          <Select value={type} onChange={setType} style={{ minWidth: 120 }}>
            {getOptions(logTypes)}
          </Select>
          <Button type='link' onClick={handleClearClick}>
            {formatMessage({ id: 'app.box.detail.audit.clear' })}
          </Button>

          <Button
            type='primary'
            icon={<SearchOutlined />}
            onClick={handleSearchClick}
          >
            {formatMessage({ id: 'app.box.detail.audit.search' })}
          </Button>
        </Space>
      )}
      <Table
        rowKey='id'
        columns={columns}
        dataSource={props.data}
        pagination={props.pagination}
      />
    </div>
  )
}
